import { useEffect, useState } from 'react';
import { Card, Typography } from 'antd';
import { useGetVisitCounterQuery } from '../../slices/visitApiSlice';

const { Title, Text } = Typography;

const VisitCounter = () => {
  const { data: visitcounter, isLoading, isError } = useGetVisitCounterQuery();
console.log(visitcounter,"visitor");
  console.log("count",visitcounter);
  
  const [visitCount, setVisitCount] = useState('');

  useEffect(() => {
    if (visitcounter && visitcounter.totalVisitors !== undefined) {
      setVisitCount(visitcounter.totalVisitors);
    }

  }, [visitcounter]);

  if (isLoading) {
    return (
      <Card title="Website Visits Count" >
        <Text>Loading...</Text>
      </Card>
    );
  }

  if (isError) {
    return (
      <Card title="Website Visits Count" >
        <Text type="danger">Error fetching data.</Text>
      </Card>
    );
  }

  return (
  <Card title="Website Visits Count" bordered={false} className='card_hover' style={{borderBottom:"2px solid #2980b9"}}>
      <Title level={3} valueStyle={{ color: "#1677ff", fontSize: "16px" }}>{visitcounter.totalVisitors}</Title>
    </Card>
  );
};

export default VisitCounter;
